//// Application Packages
import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

//// Application Slices

//// Application Components

//// Carbon Components
import { SideNavLink } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const SideNavLinkComponent = ({ required, active, link, written_name }) => {
    //////// Hooks
    const navigate = useNavigate()

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Handle Classes
    const handleClasses = () => {
        if (required && active) {
            return 'required-and-active'
        } else if (required) {
            return 'required-and-not-active'
        } else if (active) {
            return 'not-required-and-active'
        } else {
            return 'not-required-and-not-active'
        }
    }

    // Handle Navigation
    const handleNavigation = async (e, link) => {
        e.preventDefault()
        navigate(link ? link : '/')
    }

    //////// Memoization

    // Enable Class Instantiation
    const classes = useMemo(
        () => handleClasses(required, active),
        [required, active]
    )

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <SideNavLink
                className={classes ? classes : ''}
                href=""
                onClick={(e) => handleNavigation(e, `${link}`)}
            >
                {written_name}
            </SideNavLink>
        </>
    )
}

export default SideNavLinkComponent
